import React from 'react'
import classNames from "classnames";

// @material-ui/core components
import Icon from "@material-ui/core/Icon";
import withStyles from "@material-ui/core/styles/withStyles";

import dashGeneralPageStyle from "assets/jss/prehnit/views/dashGeneralPageStyle.jsx";

import { withNamespaces } from "react-i18next";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";

import CLCDistChartCard from "components/CLCDataCards/CLCDistChartCard.jsx";
import CLCTrendsChartCard from "components/CLCDataCards/CLCTrendsChartCard.jsx";
import CLCTableCard from "components/CLCDataCards/CLCTableCard.jsx";
import CLCExportCard from "components/CLCDataCards/CLCExportCard.jsx";

import { sortAreas, sortClasses, filterData } from "./dashHelpers.js";

import Map from "components/MapSimple/MapSimple.jsx";

import { API } from "services/api";

import { checkTrans } from "helpers";

class CLCDashCompareTwo extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      sortType: 0,
      sortFunc: sortClasses,

      allData: [],
      trendsData: [],
      statsData: undefined,
      syncDistChart: true,
      syncTrendsChart: true,

      zoomDistChartPrimary: 100,
      zoomDistChartSecondary: 100,
      zoomTrendsChartPrimary: 100,
      zoomTrendsChartSecondary: 100
    }

    this.handleSort = this.handleSort.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.handleSyncDistChart = this.handleSyncDistChart.bind(this);
    this.handleSyncTrendsChart = this.handleSyncTrendsChart.bind(this);

    this.handleZoomDistChartPrimary = this.handleZoomDistChartPrimary.bind(this);
    this.handleZoomDistChartSecondary = this.handleZoomDistChartSecondary.bind(this);
    this.handleZoomTrendsChartPrimary = this.handleZoomTrendsChartPrimary.bind(this);
    this.handleZoomTrendsChartSecondary = this.handleZoomTrendsChartSecondary.bind(this);

    this.getReportType = this.getReportType.bind(this);
    this.getChardIds = this.getChartIds.bind(this);
  }

  handleSort() {
    if (this.state.sortType === 0) {
      if (this._isMounted) {
        this.setState({
          sortType: 1,
          sortFunc: sortAreas
        })
      }
    } else {
      if (this._isMounted) {
        this.setState({
          sortType: 0,
          sortFunc: sortClasses
        })
      }
    }
  }

  handleSyncDistChart() {
    if (this._isMounted) {
      this.setState((prevState) => {
        return {
          syncDistChart: !prevState.syncDistChart
        }
      });
    }
  }

  handleSyncTrendsChart() {
    if (this._isMounted) {
      this.setState((prevState) => {
        return {
          syncTrendsChart: !prevState.syncTrendsChart
        }
      });
    }
  }

  _pushHistory(regionOne, regionTwo) {

    let currentPath = this.props.history.location.pathname;
    if (currentPath && currentPath.length > 0 && currentPath[0] === '/') {
      currentPath = currentPath.substring(1);
    }
    let dash = currentPath.split('/')[0];

    let newPath = "/" + dash;
    if (regionOne) {
      newPath += "/" + regionOne;

      if (regionTwo) {
        newPath += "/" + regionTwo;
      }
    }

    this.props.history.push(newPath);
  }

  handleSelect(regionOneId, regionTwoId, data = this.state.allData) {
    this._pushHistory(regionOneId, regionTwoId);
  }

  handleZoomDistChartPrimary(val) {
    if (val !== this.state.zoomDistChartPrimary) {
      if (this.state.syncDistChart) {
        if (this._isMounted) {
          this.setState({
            zoomDistChartPrimary: val,
            zoomDistChartSecondary: val
          })
        }
      } else {
        if (this._isMounted) {
          this.setState({
            zoomDistChartPrimary: val
          })
        }
      }
    }
  }

  handleZoomDistChartSecondary(val) {
    if (val !== this.state.zoomDistChartSecondary) {
      if (this.state.syncDistChart) {
        if (this._isMounted) {
          this.setState({
            zoomDistChartPrimary: val,
            zoomDistChartSecondary: val
          })
        }
      } else {
        if (this._isMounted) {
          this.setState({
            zoomDistChartSecondary: val
          })
        }
      }
    }
  }

  handleZoomTrendsChartPrimary(val) {
    if (this.state.syncTrendsChart) {
      if (this._isMounted) {
        this.setState({
          zoomTrendsChartPrimary: val,
          zoomTrendsChartSecondary: val
        })
      }
    } else {
      if (this._isMounted) {
        this.setState({
          zoomTrendsChartPrimary: val
        })
      }
    }
  }

  handleZoomTrendsChartSecondary(val) {
    if (this.state.syncTrendsChart) {
      if (this._isMounted) {
        this.setState({
          zoomTrendsChartPrimary: val,
          zoomTrendsChartSecondary: val
        })
      }
    } else {
      if (this._isMounted) {
        this.setState({
          zoomTrendsChartSecondary: val
        })
      }
    }
  }

  componentDidMount() {
    this._isMounted = true;

    checkTrans('clc');

    API.getDataAllRegions(this.props.categoryCode)
      .then(data => {
        // console.log('CLCDashCompareTwo: allData loaded');
        this.handleSelect(this.props.regionOne, this.props.regionTwo, data);
        if (this._isMounted) {
          this.setState({
            allData: data
          })
        }
      })

    API.getTrendsAllRegions(this.props.categoryCode)
      .then(data => {
        // console.log('CLCDashCompareTwo: trendsData loaded');
        if (this._isMounted) {
          this.setState({
            trendsData: data
          })
        }
      })

    API.getStatsAllRegions(this.props.categoryCode)
      .then(data => {
        // console.log('CLCDashCompareTwo: statsData loaded');
        if (this._isMounted) {
          this.setState({
            statsData: data
          })
        }
      })
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getReportType(id1, id2) {
    if (id1 && id2) {
      return "compare2";
    } else {
      if (id1 && (id2 === undefined || id2 === null)) {
        return "select1";
      } else {
        return "";
      }
    }
  }

  getChartIds(id1, id2) {
    let ids = [];
    if (id1) {
      ids.push("chart-dist-primary");
      ids.push("chart-trends-primary");
    }
    if (id2) {
      ids.push("chart-dist-secondary");
      ids.push("chart-trends-secondary")
    }
    return ids;
  }

  render() {
    const { t, classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6} lg={4}>
            <Card>
              <CardHeader color="info">
                <CardIcon color="info">
                  <Icon>play_arrow</Icon>
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{this.props.mapTitle}</h4>
              </CardHeader>
              <CardBody className={classNames(classes.cardRaised, classes.cardBodyMap)}>
                {this.state.statsData ?
                  <Map
                    data={this.state.statsData}
                    regionOne={this.props.regionOne}
                    regionTwo={this.props.regionTwo}
                    onSelect={this.handleSelect}
                    initialZoom={this.props.mapInitialZoom}
                    minZoom={this.props.mapMinZoom}
                    maxZoom={this.props.mapMaxZoom}
                    allowPan={this.props.mapAllowPan}
                    dataLayer={this.props.mapDataLayer}
                    backgroundLayer={this.props.mapBackgroundLayer ? this.props.mapBackgroundLayer : null}
                  /> : null}
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} lg={8}>
            <CLCDistChartCard
              id="chart-dist-primary"
              color="primary"
              data={filterData(this.state.allData, 'id', this.props.regionOne)}

              showSort={true}
              sortType={this.state.sortType}
              sortFunc={this.state.sortFunc}
              onSetSort={this.handleSort}

              showSync={true}
              sync={this.state.syncDistChart}
              onSetSync={this.handleSyncDistChart}

              showZoom={true}
              zoom={this.state.zoomDistChartPrimary}
              onSetZoom={this.handleZoomDistChartPrimary}
            />
            <br />
            <CLCDistChartCard
              id="chart-dist-secondary"
              color="warning"
              data={filterData(this.state.allData, 'id', this.props.regionTwo)}

              showSort={true}
              sortType={this.state.sortType}
              sortFunc={this.state.sortFunc}
              onSetSort={this.handleSort}

              showSync={true}
              sync={this.state.syncDistChart}
              onSetSync={this.handleSyncDistChart}

              showZoom={true}
              zoom={this.state.zoomDistChartSecondary}
              onSetZoom={this.handleZoomDistChartSecondary}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CLCTrendsChartCard
              id="chart-trends-primary"
              color="primary"
              height="300px"
              allData={filterData(this.state.allData, 'id', this.props.regionOne)}
              trendsData={filterData(this.state.trendsData, 'id', this.props.regionOne)}
              idCol="k3"
              areaCol="p3"

              showZoom={true}
              zoom={this.state.zoomTrendsChartPrimary}
              onSetZoom={this.handleZoomTrendsChartPrimary}

              showSync={true}
              sync={this.state.syncTrendsChart}
              onSetSync={this.handleSyncTrendsChart}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CLCTrendsChartCard
              id="chart-trends-secondary"
              color="warning"
              height="300px"
              allData={filterData(this.state.allData, 'id', this.props.regionTwo)}
              trendsData={filterData(this.state.trendsData, 'id', this.props.regionTwo)}
              idCol="k3"
              areaCol="p3"

              showZoom={true}
              zoom={this.state.zoomTrendsChartSecondary}
              onSetZoom={this.handleZoomTrendsChartSecondary}

              showSync={true}
              sync={this.state.syncTrendsChart}
              onSetSync={this.handleSyncTrendsChart}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {this.state.statsData && this.state.allData ?
              <CLCTableCard
                color="danger"
                title={t("map:class-list")}
                subtitle={t("map:level-3")}
                statsData={this.state.statsData}
                allData={this.state.allData}
                filterColumnName='id'
                filterId_1={this.props.regionOne}
                filterId_2={this.props.regionTwo}
                sortType={this.state.sortType}
                sortFunc={this.state.sortFunc}
              /> : null}
          </GridItem>
          <GridItem xs={12}>
            <CLCExportCard
              color="info"
              title={t('common:export')}
              categoryCode={this.props.categoryCode}
              hasFilter={this.props.regionOne || this.props.regionTwo}
              regionOne={this.props.regionOne}
              regionTwo={this.props.regionTwo}

              sortType={this.state.sortType}
              sortFunc={this.state.sortFunc}

              statsData={this.state.statsData}
              allData={this.state.allData}
              trendsData={this.state.trendsData}

              reportType={this.getReportType(this.props.regionOne, this.props.regionTwo)}

              chartIds={this.getChartIds(this.props.regionOne, this.props.regionTwo)}
              mapIds={["map"]}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withNamespaces()(withStyles(dashGeneralPageStyle)(CLCDashCompareTwo));